'use client';

import { useLiveScores } from '@/context/LiveScoresContext';
import MatchServices from '@/services/MatchServices';
import { useState, useEffect, useMemo } from 'react';


export function useMatchData(matchId) {
  const [matchDB, setMatchDB] = useState(null); // Match data from the database
  const dataLive = useLiveScores() || {};  // Live scores data
  const [loading, setLoading] = useState(true);
  let currentMatchLive = matchDB;
  let currentMatchChangesLive = null
  let currentMatchOddChanges = null
  let currentMatchLiveEvents = null
  let currentMatchLiveStats = null
  if (dataLive) {
  if (dataLive.liveScoreToday !== undefined && dataLive.liveScoreToday?.length > 0) {
    currentMatchLive = dataLive.liveScoreToday.find((liveM) => Number(liveM.matchId) === Number(matchId));
  }
  if (dataLive.liveScoreChanges !== undefined && dataLive.liveScoreChanges?.length > 0) {
    currentMatchChangesLive = dataLive.liveScoreChanges.find((liveChanges) => Number(liveChanges.matchId) === Number(matchId))
  }
  if (dataLive.liveOdd !== undefined && dataLive.liveOdd?.length > 0) {
    currentMatchOddChanges = dataLive.liveOdd.find((liveOdds) => Number(liveOdds.matchId) === Number(matchId))
  }
  if (dataLive.liveEvent !== undefined && dataLive.liveEvent?.length > 0) {
    currentMatchLiveEvents = dataLive.liveEvent.find((liveEvents) => Number(liveEvents.matchId) === Number(matchId))
  }
  if (dataLive?.liveStats !== undefined && dataLive?.liveStats?.length > 0) {
    currentMatchLiveStats = dataLive.liveStats.find((liveStats) => Number(liveStats.matchId) === Number(matchId))
  }
  }
  // Merge matchDB and currentMatchLive
  const matchLive = useMemo(
    () => ({
      ...matchDB,
      ...currentMatchLive,
      ...currentMatchChangesLive
    }),
    [matchDB, currentMatchLive, currentMatchChangesLive]
  );

  const oddLive = useMemo(() => ({
    ...currentMatchOddChanges
  }), [currentMatchOddChanges])

  const eventLive = useMemo(() => ({
    ...currentMatchLiveEvents
  }), [currentMatchLiveEvents])

  const statsLive = useMemo(() => ({
    ...currentMatchLiveStats
  }), [currentMatchLiveStats])

  useEffect(() => {
    
    const fetchMatch = async () => {
      if (!matchDB) { // Only fetch if matchDB is null or undefined
        setLoading(true);        
        const match = await MatchServices.getMatchById(matchId);
        setMatchDB(match);
        setLoading(false);        
      }
    };
    fetchMatch();
  }, []);
  
  return {matchLive, oddLive, eventLive, statsLive, loading}; // Return the combined match data
}
